
















































import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'
import TxParamsDialog from '@/components/Transaction/TxParamsDialog.vue'
import TxParams from '@/components/Transaction/TxParams.vue'
import TxList from '@/components/Transaction/TxList.vue'
import TxFilterDialog from '@/components/Transaction/TxFilterDialog.vue'
import TxFilter from '@/components/Transaction/TxFilter.vue'
import { ChainMap } from '@/known_blockchains'
import { Transaction } from '@/js/Transaction'
import { ITransactionParams } from '@/services/transactions'

@Component({
    components: {
        TxParamsDialog,
        TxParams,
        TxFilterDialog,
        TxFilter,
        TxList,
    },
})
export default class TxInteractive extends Vue {
    @Prop() transactions!: Transaction[]
    @Prop() assetsLoaded!: boolean
    @Prop() loading!: boolean
    @Prop() chains!: ChainMap[]

    filters: string[] = []

    setFilter(val: string[]) {
        this.filters = val
    }

    get filteredTransactions() {
        return this.transactions.filter((tx) => {
            return this.filters.some((val) => val === tx.type)
        })
    }

    // simply passes value through to the data request layer above
    emitChange(params: ITransactionParams): void {
        this.$emit('change', params)
    }
}
